<template>
    <main>
        <div class="content">
            <div>
                <div class="topic">{{lang("hr_place")}}</div>
                <div class="option">
                    <div :class="{active:companyAddress==''}" @click="chooseAdr()">全部</div>
                    <div v-for="i in placeKey" :class="{active:companyAddress==i.label}" @click="chooseAdr(i.label)">{{i.label}}</div>
                </div>
            </div>
            <div>
                <div class="topic">{{lang("hr_type")}}</div>
                <div class="option">
                    <div :class="{active:positionTypeId==''}" @click="chooseType()">全部</div>
                    <div v-for="i in typeKey" :class="{active:positionTypeId==i.value}" @click="chooseType(i.value)">{{i.label}}</div>
                </div>
            </div>
            <div>
                <div class="topic">{{lang("hr_hot")}}</div>
                <table class="list">
                    <thead>
                        <tr>
                            <th>{{lang("hr_name")}}</th>
                            <th>{{lang("hr_place")}}</th>
                            <th>{{lang("hr_salary")}}</th>
                            <th>{{lang("hr_check_more")}}>></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="i in list">
                            <td>{{i.positionTypeId}}</td>
                            <td>{{i.companyAddress}}</td>
                            <td>{{i.payMoney}}</td>
                            <td class="btn" @click="detail(i)">{{lang("hr_view_apply")}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <transition name="fade">
            <div class="loginBox" v-if="hrRequest">
                <div class="box">
                    <div class="loginBg"></div>
                    <div class="login">
                        <h3 @click.stop="">
                            <div class="title">
                                <div>职位详情</div>
                                <div class="subtitle">Position Details</div>
                            </div>
                            
                            <span class="triangle"></span>
                        </h3>
                        <div class="form" @click.stop="">
                            <dl>
                                <dt>
                                    {{lang("hr_position")}} ：{{data.positionTypeId}}
                                </dt>
                            </dl>
                            <dl>
                                <dt>
                                    {{lang("hr_place")}} ：{{data.companyAddress}}
                                </dt>
                            </dl>
                            <dl>
                                <dt>
                                    {{lang("hr_salary")}} ：{{data.payMoney}}
                                </dt>
                            </dl>
                            <dl>
                                <dt>
                                    {{lang("hr_responsibility")}} ：
                                </dt>
                                <dd>
                                    <div class="explain" v-html="data.positionExplain.replace(/\n/g,'<br/>')"></div>
                                </dd>
                            </dl>
                        </div>
                        <action class="submit" @click="submitData.positionId=data.relationId;showUpload=true;" :binding="'submit'+data.id" :ready="lang('hr_request')" success="提交成功"></action>
                        <button class="close" @click.stop="hrRequest=false"></button>
                    </div>
                </div>
            </div>
        </transition>
        <div class="cover" v-if="hrRequest"></div>
        <pager :xpages="pages" :xcurrent-page="pageNum" @pager="pageNum=$event"></pager>

        <transition name="fade">
            <upload v-if="showUpload" @close="showUpload=false" api="/api/oss/uploadFiles" title="简历上传" @confirm="submitData.resume=$event[0];request()" :single="true"></upload>
        </transition>
    </main>
</template>
<style lang="less" scoped>
    @red:#E60012;

    .content {
        width: 1200px;
        margin: 0 auto;
        background-color: #FFFFFF;
        min-height: 263px;
        position: relative;
        top: -40px;
        padding: 38px 40px 38px 30px;
        text-align: left;

        .topic {
            font-size:18px;
            font-weight:bold;
            color:#353535;
            line-height:24px;
            padding-left: 8px;
        }

        .option {
            display: flex;
            flex-wrap: wrap;
            padding-left: 8px;
            margin: 10px 0 29px;

            div {
                border: 1px solid #B2B2B2;
                border-radius:14px;
                padding: 6px 15px;
                font-size:16px;
                line-height: 17px;
                margin-right: 18px;
                cursor: pointer;
                margin-bottom: 10px;

                &.active {
                    color: @red;
                    border: 1px solid @red;
                }
            }
        }

        .list {
            margin-top: 20px;
            width: 1131px;
            border-collapse: collapse;

            tr {

                td,th {
                    &:nth-child(1) {
                        padding-left: 8px;
                    }

                    &:nth-child(4) {
                        width: 168px;
                        text-align: center;
                    }
                }
            }

            thead {
                font-size:16px;
                font-weight:400;
                color:#343434;
                line-height:62px;

                tr {
                    border-bottom: 1px solid #D2D2D2;
                }

            }

            tbody {
                font-size:14px;
                font-weight:400;
                color:#343434;
                line-height:59px;

                tr:not(:last-child) {
                    border-bottom: 1px solid #D2D2D2;
                }

                .btn {
                    color: #FF0000;
                    cursor: pointer;
                }
            }
       }
    }

    .loginBox {
		position: fixed;
		width: 100%;
		height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
		left: 0;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 102;
		// will-change: opacity;

		.box {
			position: relative;
			width: 440px;
			height: 581px;
		}
        .loginBg {
			position: absolute;
			top: 23px;
            width:440px;
            height:534px;
            z-index: 101;
            background-color: @red;
        }

        .login {
			position: absolute;
			left: 20px;
		    width: 400px;
		    height: 581px;
            background-color: white;
            padding: 26px 20px;
		    border: none;
            overflow: hidden;
            z-index: 102;

		    h3 {
			    text-align: left;
                margin: 0 0 20px 0;
                font-size: 20px;
                font-weight:400;
                background:url(../assets/images/nav/logo_bg.png) no-repeat left center;
                padding-left: 9px;

                .subtitle {
                    font-size:16px;
                    font-family:Roboto;
                    font-weight:900;
                    color:#888888;
                }

                .title{
                    width: 151px;
                    display: inline-block;
                }

                .triangle {
                    display: inline-block;
                    border:5px solid transparent;
                    border-bottom:5px solid @red;
                    border-right:5px solid @red;

                }
            }

		    .form {
                margin-bottom: 20px;
                font-size:16px;
                font-weight:400;

			    strong {
				    color: #e60012;
				    margin-right: 2px;
			    }

			    dl {
				    margin: 0 0 21px 0;

				    dt {
					    text-align: left;
					    color: #363636;
					    line-height: 24px;
				    }

				    dd {
                        margin: 0;
                        text-align: left;
                        color: #363636;
                        
                        .explain {
                            max-height: 256px;
                            overflow: scroll;
                        }
				    }
			    }
		    }

		    .submit {
			    border: none;
			    background-color: #e60012;
			    color: white;
			    height: 40px;
			    width: 88%;
                transition: all .2s;
                position: absolute;
                bottom: 29px;
                left: 6%;

				&:disabled {
			    	opacity: 0.3;
			    }

			    &.error,
			    &.success,
			    &.working {
				    color: white;
				    display: flex;
				    justify-content: center;

				    span {
					    flex: none;
					    order: 1;
				    }

				    &:after {
					    background-color: transparent;
					    border-left: none;
				    }

				    &:before {
					    position: relative;
					    order: 2;
					    margin-left: 5px;
				    }
			    }

			    &.working {
				    &:before {
					    border-top-color: white;
				    }

				    &:after {
					    display: none;
				    }
			    }

			    &:hover {
			    	background-color: #e60012;
				    opacity: .8;
			    }
		    }

		    .close {
			    border: none;
		    	width: 17px;
		    	height: 17px;
		    	position: absolute;
		    	right: 22px;
		    	top: 22px;
		    	background: transparent url(../assets/images/index/close.png) center/auto no-repeat;
		    }

		    &.expand {
		    	width: 400px;
		    	height: 515px;
		    	background-color: white;
		    	background-image: none;
		    	border-radius: 5px;
		    	top: calc(50% - 200px);
		    	z-index: 20;
		    	cursor: default;
		    	padding: 30px;
		    	transition: all .4s, z-index 0s;
		    }
        }
    }
    
    .cover{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .7);
        z-index: 100;
    }
</style>

<script>
    export default {
        data() {
            return {
                hrRequest:false,
                typeKey:[],
                placeKey:[],
                companyAddress:'',
                positionTypeId:'',
                list:[],
                data:{},
                showUpload:false,
                submitData: {
                    positionId: undefined,
                    resume: undefined
                }
            }
        },
        methods: {
            detail(item){
                this.hrRequest=true;
                this.data=item;
            },
            getPlaceKey(){
                var that = this;
                that.companyAddress = '';
				ajax.call(this, {
					url: "/admin/category/typeKey",
					data: {
                        // SERVER_SORT服务,PRODUCT_SORT产品,DEVICE_SORT设备,TECHNOLOGY_SORT工艺,POSITION_SORT职位,VIDEO_SORT视频,OTHER_SORT其他
						typeKey : "OTHER_SORT"
					},
					s(res) {
                        that.placeKey=res.data;
					}
				});
            },
            getTypeKey(){
                var that = this;
                that.positionTypeId = '';
				ajax.call(this, {
					url: "/admin/category/typeKey",
					data: {
                        // SERVER_SORT服务,PRODUCT_SORT产品,DEVICE_SORT设备,TECHNOLOGY_SORT工艺,POSITION_SORT职位,VIDEO_SORT视频,OTHER_SORT其他
						typeKey : "POSITION_SORT"
					},
					s(res) {
                        that.typeKey=res.data;
					}
				});
            },
            chooseAdr(index=''){
                this.companyAddress=index;
                this.getList();
            },
            chooseType(index=''){
                this.positionTypeId=index;
                this.getList();
            },
            getList(){
                var that = this;
				ajax.call(this, {
					url: "/bloc/position/list/bloc",
					data: {
                        companyAddress: that.companyAddress,
                        positionTypeId: that.positionTypeId,
                        pageSize: 4
					},
					s(res) {
                        that.list=res.data;
					}
				});
            },
            request() {
                var that = this;
                ajax.call(this, {
                    binding: "submit" + this.submitData.positionId,
                    url: "/bloc/resume/add",
                    type: "post",
                    data: this.submitData,
					s(res) {
                        // that.hrRequest=false;
                        that.$root.alertAuto=true;
                        that.$root.alert.push("投递成功！");	
					}
                });
            }
        },
        mounted() {
           this.getTypeKey();
           this.getPlaceKey();
           this.getList();
        },
        watch: {
			"$root.language"() {
				this.getTypeKey();
                this.getPlaceKey();
                this.getList();
			},

		}
    }
</script>